import { ChannelStatus } from '@/models/channels'

import { mountMemberChannelsArray } from './utils'

const setChannelsWithStaff = (state, channels) => {
  const channelsWithStaff =
    channels?.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) || []

  Object.assign(state, { channelsWithStaff })
}

const setMemberChannels = (state, channels) => {
  const memberChannels = mountMemberChannelsArray(channels)

  Object.assign(state, { memberChannels })
}

const updateActiveChannels = (state, activeChannelsUpdated) => {
  const archivedChannels = state.memberChannels.filter(
    channel => channel.status === ChannelStatus.ARCHIVED
  )

  const memberChannels = mountMemberChannelsArray(
    activeChannelsUpdated.concat(archivedChannels)
  )

  Object.assign(state, {
    memberChannels
  })
}

const setPersonId = (state, personId) => {
  Object.assign(state.member, { personId })
}

export default {
  setChannelsWithStaff,
  setMemberChannels,
  setPersonId,
  updateActiveChannels
}
